import React, { FormEvent, forwardRef, ReactElement } from 'react';
import cx from "classnames";
import styled from "styled-components";
import IBuildrProps from '../../utilities/IBuildrProps';
import { AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from '../../utilities/automation';
import { IFormRowProps } from './FormRow'

interface IFormProps extends IBuildrProps {
    formName: string;
    formAction: string;
    campaignId: string;
    eloquaSiteId: string;
    className: string;
    children: any;
}

export default styled(forwardRef(function({
    cmsId,
    editorClassObj,
    formName,
    formAction,
    campaignId,
    eloquaSiteId,
    className,
    children
}: IFormProps, ref: any) {
    const isWhite = className && className.includes('light-inputs');

    function submitHandler(e: FormEvent<HTMLFormElement>) {
        if (cmsId) e.preventDefault();
    }

    return (
        <form data-id={cmsId} ref={ref} onSubmit={submitHandler} className={cx(className, editorClassObj, 'form-custom')} action={formAction} data-test-id={createDataTestId({ feature: AutomationTestIdFeature.FORM, element: AutomationTestIdElementType.FORM })}>
            <input type="hidden" name="elqFormName" value={formName} />
            <input type="hidden" name="elqCampaignId" value={campaignId} />
            <input type="hidden" name="elqSiteId" value={eloquaSiteId} />
            {React.Children.map(children,
                (child: ReactElement<IFormRowProps>) => {
                    return React.cloneElement(child, {
                        isWhite,
                    });
                })
            }
        </form>
    )
}))``;
